exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".topbarmenu-list-override .list__tile{padding-left:16px;padding-right:16px}", "", {"version":3,"sources":["/home/vishal/Documents/work/LENS_workspace/lens3/lens-frontend/src/components/TopbarMenu.vue"],"names":[],"mappings":"AACA,sCACE,kBAAmB,AACnB,kBAAoB,CACrB","file":"TopbarMenu.vue","sourcesContent":["\n.topbarmenu-list-override .list__tile {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/TopbarMenu.vue
// module id = 1428
// module chunks = 78